import { Context } from "../../index";
import React, { useContext } from "react";
import { observer } from "mobx-react-lite";
import { Form } from "react-bootstrap";

const LangFiltDropDown = observer(() => {
    const { book } = useContext(Context);

    const handleLanguageChange = (language) => {
        const selectedId = Number(language.target.value);
        const selectedLanguage = book.languages.find(type => type.id === selectedId) || '';
        book.setSelectedLanguage(selectedLanguage);
    };

    return (
        <div className="mb-0 border-success ">
            <Form.Select
                id="langSelect"
                value={book?.selectedLanguage?.id || ""}
                onChange={handleLanguageChange}
                style={{ width: '120px' }}
                className="form-select-sm border border-success text-success"
            >
                <option value="">Language...</option>
                {book.languages.map((lang) => (
                    <option key={lang.id} value={lang.id}>
                        {lang.language}
                    </option>
                ))}
            </Form.Select>

        </div>

    );
});

export default LangFiltDropDown;
